.template {
  opacity: 0;
  height: 0;
}
